import React from "react"
import { Link } from "gatsby"
import Img from "gatsby-image"
import "./style.css"
import useLang from "../../hooks/useLang"

export default function ProductsBox({ products }) {
  const isAr = useLang() === "ar"
  const moreText = isAr ? "المزيد" : "More"

  // Helper function to limit words
  const limitWords = (text, limit) => {
    if (!text) return ""
    const words = text.split(" ")
    if (words.length <= limit) return text
    return words.slice(0, limit).join(" ") + "..."
  }

  return (
    <div className={`products-page ${isAr ? "products-ar-font" : ""}`}>
      <div className="container">
        <div className="row">
          <div className="productGrid">
            {products.map(({ title, name, subname, path, description, images = [], cmsImageUrl }, index) => (
              <div className="row mb-5" key={`${path || name || title}-${index}`}>
                <div className="col-md-7">
                  <div className="pdThumb">
                    {cmsImageUrl ? (
                      <img
                        src={cmsImageUrl}
                        alt={name || title || ""}
                        className="w-100 benchmark-cms-product-image"
                        loading="lazy"
                        decoding="async"
                      />
                    ) : images?.[0]?.image?.childImageSharp?.fluid ? (
                      <Img
                        fluid={images[0].image.childImageSharp.fluid}
                        alt={name}
                        className="w-100"
                      />
                    ) : (
                      <div className="benchmark-product-image-placeholder" />
                    )}
                  </div>
                </div>
                <div className="col-md-5">
                  <div className={`pdDetails product-content-card ${isAr ? "pdDetails--ar" : ""}`}>
                    <h2 className="ml-4">{name}</h2>
                    <h3 className="ml-4 pdSubname">{subname}</h3>
                    <p className="ml-4">{limitWords(description, 20)}</p>
                    <Link to={"/" + path} className="ml-4 BtnAction">
                      {moreText}
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
